const AUTH_TOKEN_DETAIL_PATTERNS = [
  'authorization token',
  'unexpired security token',
]

export const guestReestablishCode = 'guest_reestablish_required'
export const accountQuarantinedCode = 'account_quarantined'

const KEPT_BEARER_CODES = new Set([
  guestReestablishCode,
  accountQuarantinedCode,
])

export const isAuthTokenRejectedJsonApiError = (error) => {
  if (!error || typeof error !== 'object') return false
  if (KEPT_BEARER_CODES.has(error.code)) return false

  const status = error.status
  if (status === 401 || status === '401') {
    return true
  }

  if (error.title === 'Not Authenticated') {
    return true
  }

  const detail = typeof error.detail === 'string' ? error.detail.toLowerCase() : ''
  return AUTH_TOKEN_DETAIL_PATTERNS.some((pattern) => detail.includes(pattern))
}
